var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconArrow = function SvgIconArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.535,
    height: 20.816,
    viewBox: "0 0 10.535 20.816",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-arrow",
    d: "M12.031.82a1.5,1.5,0,0,1,1.938,0l8.905,7.535A1.5,1.5,0,0,1,21.905,11H4.095a1.5,1.5,0,0,1-.969-2.645Z",
    transform: "translate(11 -2.592) rotate(90)",
    fill: "#7d848b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconArrow, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC41MzUiIGhlaWdodD0iMjAuODE2IiB2aWV3Qm94PSIwIDAgMTAuNTM1IDIwLjgxNiI+DQogIDxwYXRoIGlkPSJpY29uLWFycm93IiBkPSJNMTIuMDMxLjgyYTEuNSwxLjUsMCwwLDEsMS45MzgsMGw4LjkwNSw3LjUzNUExLjUsMS41LDAsMCwxLDIxLjkwNSwxMUg0LjA5NWExLjUsMS41LDAsMCwxLS45NjktMi42NDVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMSAtMi41OTIpIHJvdGF0ZSg5MCkiIGZpbGw9IiM3ZDg0OGIiLz4NCjwvc3ZnPg0K";
export { ForwardRef as ReactComponent };